// AuthLayout.js
import { useEffect } from "react";
import "./AuthLayout.scss"; // You can add your styles here
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthenticated } from "../../../Routes/AuthHelper";
const AuthLayout = () => {
  const isAuthentic = isAuthenticated();
  const navigate = useNavigate();
  useEffect(() => {
    if (isAuthentic)
      navigate("/sales", {
        replace: true,
      });
  }, [isAuthentic, navigate]);

  return <div className="auth-layout">{!isAuthentic && <Outlet />}</div>;
};

export default AuthLayout;
